module.exports = __webpack_public_path__ + "assets/painter.svg?073f46dddfaef488cfa8174ff3f8cace";